import { Routes } from '@angular/router';
import { NotificationsPath } from '@core/constants';
import { systemSettingGuard } from '@app/core/guards/system-setting/system-setting.guard';
import { privilegeGuard } from '@core/guards/privilege/privilege.guard';
import {
  V1ClassicPageComponent,
  v1RootGuard
} from '@core/guards/v1-default/v1-default.guard';

export const mainRoutes: Routes = [
  {
    path: 'reports',
    title: 'Reports',
    loadChildren: () =>
      import('@features/reports/reports.routes').then((m) => m.reportsRoutes),
    canActivate: [privilegeGuard],
    canActivateChild: [privilegeGuard],
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    data: {
      permission: ['report_view']
    }
  },

  {
    path: 'crm',
    title: 'CRM',
    loadChildren: () =>
      import('@features/crm/crm.routes').then((m) => m.crmRoutes),
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange'
  },

  {
    path: 'maintenance',
    title: 'Maintenance',
    loadChildren: () =>
      import('@features/maintenance/maintenance.routes').then(
        (m) => m.maintenanceRoutes
      ),
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange'
  },

  {
    path: 'productivity',
    title: 'Productivity',
    loadChildren: () =>
      import('@features/productivity/productivity.routes').then(
        (m) => m.productivityRoutes
      ),
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange'
  },

  {
    path: 'patients',
    title: 'Patients',
    loadChildren: () =>
      import('@features/patients/patients.routes').then(
        (m) => m.patientsRoutes
      ),
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange'
  },
  {
    path: 'pickup-and-delivery',
    loadChildren: () =>
      import('@features/pickup-and-delivery/pickup-and-delivery.routes').then(
        (m) => m.pickupAndDeliveryRoutes
      ),
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    canActivate: [systemSettingGuard],
    data: {
      systemSetting: 'pickup_delivery_appointment_automation'
    }
  },
  {
    path: 'purchasing',
    loadChildren: () =>
      import('@features/purchasing/purchasing.routes').then(
        (m) => m.purchasingRoutes
      ),
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    canActivate: [systemSettingGuard],
    data: {
      systemSetting: 'enable_new_purchasing_inventory'
    }
  },
  {
    path: NotificationsPath,
    title: 'Notifications',
    loadChildren: () =>
      import('@features/notifications/notifications.routes').then(
        (m) => m.notificationsRoutes
      ),
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange'
  },
  {
    path: '',
    component: V1ClassicPageComponent,
    canActivate: [v1RootGuard]
  }
];
